export default __webpack_public_path__ + "static/media/orphanswords-ascent-05.a1b09392.jpg";